class HeaderDrawer extends SideDrawer {
  constructor() {
    super();
    this.moved = false;
    this.header = this.header || document.querySelector('.header-wrapper');
  }
  

  open(triggeredBy) {
    if (this.header) {
      this.header.classList.add('open-header-drawer');
      document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom)}px`);
    }
    window.addEventListener('resize', this.onResize);
    super.open(triggeredBy);
  }

  close() {
    super.close();
    if (this.header) {
      this.header.classList.remove('open-header-drawer');
      document.documentElement.style.removeProperty('--header-bottom-position');
    }
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header && document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom)}px`);
  }
}

customElements.define('header-drawer', HeaderDrawer);

if (!customElements.get('menu-details')) {
  customElements.define('menu-details',
    class MenuDetails extends HTMLElement {
      constructor() {
        super();
        this.summary.addEventListener('click', this.onSummaryClick.bind(this));
        this.button.addEventListener('click', this.onButtonClick.bind(this));
      }

      get parent() {
        return this.closest('[data-menu-details-parent]');
      }

      get detailsContainer() {
        return this.querySelector('details');
      }

      get summary() {
        return this.querySelector('summary');
      }

      get button() {
        return this.querySelector('button:not(.drawer__close)');
      }

      setMegaMenuOpen() {
        const megaMenu = this.querySelector('mega-menu');
        megaMenu?.setAttribute('open', true);
      }
  
      setMegaMenuClose() {
        const megaMenu = this.querySelector('mega-menu');
        megaMenu?.removeAttribute('open');
      }

      onSummaryClick(e) {
        e.preventDefault();
        this.setMegaMenuOpen();
        if (this.classList.contains('menu-details-lv2')) {
          const isActive = this.classList.contains('active');
          document.querySelectorAll('menu-details.menu-details-lv2').forEach((el) => {
              if (el !== this) {
                  el.classList.remove('active');
                  el.querySelector('details')?.removeAttribute('open');
                  el.querySelector('summary')?.setAttribute('aria-expanded', false);
              }
          });
          if (isActive) {
              this.classList.remove('active');
              this.detailsContainer.removeAttribute('open');
              this.summary.setAttribute('aria-expanded', false);
          } else {
              this.classList.add('active');
              this.detailsContainer.setAttribute('open', true);
              this.summary.setAttribute('aria-expanded', true);
          }
        } else {
          setTimeout(() => {
              this.parent.classList.add('active');
              this.classList.add('active');
              this.detailsContainer.setAttribute('open', true);
              this.summary.setAttribute('aria-expanded', true);
              this.closest('header-drawer')?.classList.add('hidden__menu-title');
          }, 100);
        }
      }

      onButtonClick() {
        this.setMegaMenuClose();
        this.parent.classList.remove('active');
        this.classList.remove('active');
        this.detailsContainer.removeAttribute('open');
        this.summary.setAttribute('aria-expanded', false);
        this.closest('header-drawer')?.classList.remove('hidden__menu-title');
      }
    }
  )
}